/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NamespaceSearchKey { 
    /**
     * The charge code associated with one or more namespaces
     */
    chargeCode: string;
    /**
     * An optional boolean flag that specifies if charge code must be set (has a non blank value) for the namespaces that we want to retrieve                
     */
    mustHaveChargeCode?: boolean;
}
